import {css} from 'lit';
export const styles = css`:host {
  --border-radius: 4px;

  display: block;
}

a {
  --background: var(--primary-000);
  --font: var(--text-primary);

  display: flex;
  padding: 8px;
  border-radius: var(--border-radius);
  text-decoration: none;
  background-color: var(--background);
  color: var(--font);
  /* stylelint-disable-next-line csstree/validator */
  transition: background-color 0.2 ease;
  border-top: 1px solid transparent;
}

a.read {
  --background: transparent;

  border-color: var(--border);
}

a.permanent {
  --background: var(--primary-500);
  --font: var(--primary-000);
}

.permanent .title {
  color: var(--contrast-light);
  font-weight: 600;
}

.permanent ef-timeago {
  color: var(--primary-200);
}

@media (hover: hover) {
  a:hover {
    --background: var(--primary-100);
  }
}

a:active {
  --background: var(--primary-200);
  --link-text-active: var(--text-primary);
}

@media (hover: hover) {
  a.permanent:hover {
    --background: var(--primary-600);
    --link-text-hover: var(--contrast-light);
  }
}

:host .permanent:active {
  --background: var(--primary-700);
  --link-text-active: var(--contrast-light);
}

ef-avatar {
  margin-right: 8px;
}

.info {
  line-height: 1.4;
  font-size: 14px;
}

.date {
  margin-top: 2px;
  color: var(--text-secondary);
  font-size: 12px;
}

.title {
  margin-bottom: 4px;
  font-size: 15px;
  color: var(--primary-500);
}

.title slot::slotted(*) {
  margin: 0;
}

ef-timeago {
  white-space: nowrap;
}
`;
export default styles;
